import React from 'react';
import { Mui } from '../..';

export const Primary = props => <Mui.Icon {...props}>info_outlined</Mui.Icon>;
export const Secondary = props => <Mui.Icon {...props}>info_outlined</Mui.Icon>;
export const Info = props => <Mui.Icon {...props}>info_ourlined</Mui.Icon>;
export const Warning = props => <Mui.Icon {...props}>warning_outlined</Mui.Icon>;
export const Success = props => <Mui.Icon {...props}>check_circle_outlined</Mui.Icon>;
export const Failure = props => <Mui.Icon {...props}>error_outlined</Mui.Icon>;
